import { Helmet } from "react-helmet-async"
import { AIBuilderUsageView } from "../../../Trips"

export default function CreditConsumptionaiAIBuilderPage() {
	return (
		<>
			<Helmet>
				<title>AI Itinerary Credits</title>
			</Helmet>
			<AIBuilderUsageView />
		</>
	)
}
